import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const Poll = () => {

    document.getElementsByTagName('body')[0].classList.add('question-box-body');
    document.getElementsByTagName('body')[0].setAttribute('style', 'height: 100vh !important');

    const baseUrl = 'https://petromah.sabinarya.com/service/api/';

    const [showLoading, setShowLoading] = useState(true);
    const [submitAnswer, setSubmitAnswer] = useState(false);
    const { token } = useParams();
    const [businessTitle, setBusinessTitle] = useState('');
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [comments, setComments] = useState('');
    const [guild, setGuild] = useState(0);
    const [logo, setLogo] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        axios.post(`${baseUrl}Question/fetchByToken?tokenId=${token}`).then(({ data }) => {
            if (data.status) {
                setQuestions(old => data.result.result);
                setBusinessTitle(data.result.businessTitle);
                setGuild(data.result.guildId);
                setLogo(data.result.logo);
            } else
                setMessage(data.message);
        }).finally(() => {
            setShowLoading(false);
        })
    }, [])

    const answerQuestion = (e,questionId,answerWeight) => {
        let stars = document.getElementsByClassName(`question-star-${questionId}`);
        for(let i = 0;i < stars.length;i++)
            if(typeof stars[i] === 'object')
                stars[i].classList.remove('selected');
        e.target.classList.add('selected');
        let oldAnswers = answers;
        let hasAnswer = oldAnswers.findIndex(answer => answer.questionId == questionId);
        if(hasAnswer >= 0)
            oldAnswers[hasAnswer].answerWeight = answerWeight;
        else
            oldAnswers.push({
                questionId,
                answerWeight
            });
        setAnswers(old => [...oldAnswers]);
    }



    // const answerQuestion = (e, questionId, answerWeight) => {
    //     let stars = document.getElementsByClassName(`raiting-emojie-${questionId}`);
    //     for (let i = 0; i < stars.length; i++)
    //         if (typeof stars[i] === 'object')
    //             stars[i].classList.remove('active');
    //     e.currentTarget.classList.add('active');
    //     let oldAnswers = answers;
    //     let hasAnswer = oldAnswers.findIndex(answer => answer.questionId == questionId);
    //     if (hasAnswer >= 0)
    //         oldAnswers[hasAnswer].answerWeight = answerWeight;
    //     else
    //         oldAnswers.push({
    //             questionId,
    //             answerWeight
    //         });
    //     setAnswers(old => [...oldAnswers]);
    // }

    const submitVote = () => {
        setShowLoading(true);
        const postedData = {
            token,
            ans: answers,
            comments
        };
        axios.post(`${baseUrl}Answer/set`, postedData).then(({ data }) => {
            if (data.status)
                setSubmitAnswer(true);
            else
                Swal.fire({
                    title: 'خطا',
                    text: 'خطایی در ثبت نظر رخ داده است',
                    icon: 'error',
                    confirmButtonText: 'متوجه شدم'
                });
        }).catch(() => {
            Swal.fire({
                title: 'خطا',
                text: 'خطایی در ثبت نظر رخ داده است',
                icon: 'error',
                confirmButtonText: 'متوجه شدم'
            });
        }).finally(() => {
            setShowLoading(false);
        });
    }

    return (
        <div id="questions-box">
            <h1>نظرسنجی</h1>
            <div id="main-box">
                {showLoading ? <div className="poll-loading">
                    <img src="/assets/images/loader.svg" />
                    <h4>لطفاً صبر کنید ...</h4>
                </div> : ''}
                {!submitAnswer ?
                    <>
                        {questions.length ?
                            <>
                                <img id="chef-image" src={`data:image/jpeg;base64,${logo}`} />
                                <p id="poll-description">همکار گرامی شما از مجموعه {businessTitle} استفاده نموده اید. لطفاً با ثبت نظر خود ما را در امر بهبود خدمات یاری نمایید.</p>
                                {questions.map(question => (
                                    <div className="question" key={question.id}>
                                        <h4>{question.title}</h4>
                                        <div className="emojie-parent">
                                            <ul className="ratings" dir="ltr">
                                                <span className="rating-last-star">10</span>
                                                <li className={`star star-10 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,10)}></li>
                                                <li className={`star star-9 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,9)}></li>
                                                <li className={`star star-8 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,8)}></li>
                                                <li className={`star star-7 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,7)}></li>
                                                <li className={`star star-6 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,6)}></li>
                                                <li className={`star star-5 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,5)}></li>
                                                <li className={`star star-4 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,4)}></li>
                                                <li className={`star star-3 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,3)}></li>
                                                <li className={`star star-2 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,2)}></li>
                                                <li className={`star star-1 question-star-${question.id}`} onClick={e => answerQuestion(e,question.id,1)}></li>
                                                <span className="rating-first-star">1</span>
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                                <div className="question">
                                    <label>نظرات</label>
                                    <textarea rows="3" onKeyUp={e => setComments(e.target.value)}></textarea>
                                </div>
                                <button className="submit-btn" onClick={submitVote}>ثبت نظر</button>
                            </>
                            :
                            <>
                                <h3>خطا</h3>

                                <p>{message || 'نظرسنجی مورد نظر یافت نشد !'} </p>
                            </>
                        }
                    </>
                    :
                    <>
                        <i className='fs-30'>😊</i>
                        <p>نظر شما با موفقیت در سیستم ثبت شد</p>
                    </>
                }
            </div>
        </div>
    );
}

export default Poll;